import { create } from 'zustand';

import type { UserContext } from 'scbk-services/types/shared-context/user-context';
import { createJSONStorage, persist } from 'zustand/middleware';

interface UserContextState {
    commonContext: UserContext.CommonContext;
    getCommonContext: () => UserContext.CommonContext;
    resetUserCommonContext: () => void;
    setUserCommonContext: (context: UserContext.CommonContext) => void;
    updateUserCommonContext: (context: UserContext.CommonContext) => void;

    additionalContext: Record<string, unknown>;
    getAdditionalContext: () => Record<string, unknown>;
    resetUserAdditionalContext: () => void;
    setUserAdditionalContext: (context: Record<string, unknown>) => void;
    updateUserAdditionalContext: (context: Record<string, unknown>) => void;
}

export const useUserContextStore = create<UserContextState>()(
    persist(
        (set, get) => ({
            commonContext: {},

            getCommonContext: () => get().commonContext,

            resetUserCommonContext: () => set({ commonContext: {} }),
            setUserCommonContext: (context: UserContext.CommonContext) =>
                set({ commonContext: context }),
            updateUserCommonContext: (context: UserContext.CommonContext) =>
                set((state) => ({ commonContext: { ...state.commonContext, ...context } })),

            additionalContext: {},
            getAdditionalContext: () => get().additionalContext,
            resetUserAdditionalContext: () => set({ additionalContext: {} }),
            setUserAdditionalContext: (context: Record<string, unknown>) =>
                set({ additionalContext: context }),
            updateUserAdditionalContext: (context: Record<string, unknown>) =>
                set((state) => ({
                    additionalContext: { ...state.additionalContext, ...context },
                })),
        }),
        {
            name: 'user-context-storage', // 세션스토리지에 저장될 키 이름
            storage: createJSONStorage(() => sessionStorage),
            // skipHydration: true, // 웹뷰 초기 렌더링시 hydrate 시점 제어 필요시 주석해제
        },
    ),
);
